<template>
  <div>
    <form-wizard ref="formwizard" @on-complete="addUser($event)" :start-index="1">
      <tab-content class="mt-4 mb-6">
        <a-form class="form-control" :form="form">
          <span class="text-opacity text-bold">BASIC INFORMATION</span>
          <a-row class="mt-2">
            <a-col :span="12">
              <a-form-item class="mr-3">
                <h4 class="text-opacity">First Name</h4>
                <a-input
                  v-decorator="['first_name', {initialValue: user.first_name, rules: [{ required: true, message: 'Please enter first name for this user' }] }]"
                  class="custom-input"
                  placeholder="What is the first name of this User"
                />
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item>
                <h4 class="text-opacity">Last Name</h4>
                <a-input
                  v-decorator="['last_name', { initialValue: user.last_name, rules: [{ required: true, message: 'Please enter last name for this user' }] }]"
                  class="custom-input"
                  placeholder="What is the last name of this User"
                />
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item class="mr-3">
                <h4 class="text-opacity">Email Address</h4>
                <a-input
                  v-decorator="['email', {initialValue: user.email, rules: [{ required: true, message: 'Please enter the email address of this user ' }] }]"
                  class="custom-input"
                  placeholder="What is the Email Address of this user"
                  :disabled="mode == 'edit' ? true : false"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item>
                <h4 class="text-opacity">Home Telephone</h4>
                <a-input
                  v-decorator="['home_telephone', {initialValue: user.phone_number, rules: [{ required: true, message: 'Please enter home telephone' }] }]"
                  class="custom-input"
                  placeholder="What is the Name of this User"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-show="mode !=='edit'">
            <a-col :span="12">
              <a-form-item class="mr-3">
                <h4 class="text-opacity">
                  Username
                  <sup>optional</sup>
                </h4>
                <a-input
                  v-decorator="['username', { initialValue: user.username, rules: [{ required: true, message: 'Please enter a username for this user' }] }]"
                  class="custom-input"
                  placeholder="Enter a username for this user"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item>
                <h4 class="text-opacity">Password</h4>
                <a-input
                  v-decorator="['password', { rules: [{ required: mode === 'edit' ? false : true, message: 'Please enter a password for this user' }] }]"
                  class="custom-input"
                  placeholder="Enter a Password for this user"
                  :type="display"
                  :disabled="mode && mode === 'edit' ? true: false"
                />
                <span class="show-toggle">
                  <a-icon @click="toggleShow" type="eye" v-show="show"/>
                  <a-icon @click="toggleShow" type="eye-invisible" v-show="hide"/>
                </span>
              </a-form-item>
              <div style="margin-top:-20px">
                <small class="text-opacity">
                  An email would be sent to
                  <b class="text-bold">obodugorapheal@gmail</b> with steps to get onboard.
                </small>
              </div>
            </a-col>
          </a-row>
          <span class="text-opacity text-bold">LOCATION INFORMATION</span>
          <a-row class="mt-2">
            <a-col :span="12">
              <a-form-item class="mr-3">
                <h4 class="text-opacity">
                  Country of Residence
                  <sup>optional</sup>
                </h4>
                <a-select
                  showSearch
                  class="custom-select"
                  @change="setCountry"
                  v-model="location.selected_country"
                  placeholder="Select the country of this user"
                >
                  <a-select-option
                    :key="index"
                    :value="country.name"
                    v-for="(country,index) in countries"
                  >{{country.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item>
                <h4 class="text-opacity">
                  State of Residence
                  <sup>optional</sup>
                </h4>
                <a-select
                  showSearch
                  class="custom-select"
                  v-model="location.selected_state"
                  @change="setState"
                  placeholder="Select state of this user"
                >
                  <a-select-option
                    :key="index"
                    :value="state.name"
                    v-for="(state,index) in states"
                  >{{state.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item class="mr-3">
                <h4 class="text-opacity">
                  City of Residence
                  <sup>optional</sup>
                </h4>
                <a-select
                  class="custom-select"
                  v-model="location.selected_city"
                  placeholder="Select city of this user"
                >
                  <a-select-option
                    :key="index"
                    :value="city.name"
                    v-for="(city,index) in cities"
                  >{{city.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item>
                <h4 class="text-opacity">
                  Zip Code
                  <sup>Optional</sup>
                </h4>
                <a-input
                  v-decorator="['zip_code', {initialValue: user.zip_postal_code, rules: [{ required: true, message: 'Please Enter User name for User' }] }]"
                  class="custom-input"
                  placeholder="Enter a zipcode for this user's location"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="24">
              <a-form-item>
                <h4 class="text-opacity">
                  Address
                  <sup>Optional</sup>
                </h4>
                <a-textarea
                  v-decorator="['address', {initialValue: user.street_address}]"
                  placeholder="What is the address of this user"
                  :autosize="{ minRows: 2, maxRows: 6 }"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <span class="text-opacity text-bold">ROLE ACCESS</span>
          <a-row class="mt-2">
            <a-col :span="12">
              <h5
                class="text-opacity"
              >Roles helps allocate what services every user has access to. Each roles are related to set of Permissions, which has been assigned on the Permissions page.</h5>
            </a-col>
          </a-row>
          <a-row class="mt-2">
            <a-col :span="24">
              <a-form-item class>
                <h4 class="text-opacity">Roles</h4>
                <a-select
                  showSearch
                  class="custom-select"
                  v-decorator="[
                        'roles',
                        {initialValue: user.role_id},
                        { rules: [{ required: true, message: 'Please assign a role to this user' }] },
                      ]"
                  placeholder="Select a role to be assigned to user"
                >
                  <a-select-option
                    :key="index"
                    v-for="(role,index) in roles"
                    :value="role.id"
                  >{{role.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { setTimeout } from "timers";
export default {
  data() {
    return {
      hide: false,
      show: true,
      display: "password",
      form: this.$form.createForm(this, { name: "coordinated" }),

      location: {
        selected_country: "",
        selected_state: "",
        selected_city: ""
      }
    };
  },
  props: ["user", "mode", "roles"],
  computed: {
    countries() {
      if (this.user && this.user.country) {
        this.location.selected_country = this.user.country.name;
      }
      return this.$store.getters.countries;
    },
    states() {
      if (this.user && this.user.state) {
        this.location.selected_state = this.user.state.name;
      }
      if (this.location.selected_country !== "") {
        let coutr = this.countries.find(
          s => s.name === this.location.selected_country
        );
        if (coutr) {
          return this.$store.getters.states.filter(
            s => s.country_id === coutr.id
          );
        }
      }
      return [];
    },
    cities() {
      if (this.user && this.user.city) {
        this.location.selected_city = this.user.city.name;
      }
      if (this.location.selected_state !== "") {
        let sta = this.states.find(
          s => s.name === this.location.selected_state
        );
        if (sta) {
          return this.$store.getters.cities.filter(s => s.state_id === sta.id);
        }
      }

      return [];
    }
  },
  methods: {
    toggleShow() {
      if (this.hide === false) {
        this.hide = true;
        this.display = "password";
      } else {
        this.hide = false;
        this.display = "text";
      }
      if (this.show == true) {
        this.show = false;
        this.display = "text";
      } else {
        this.show = true;
        this.display = "password";
      }
    },
    setCountry(e) {
      //set the states to empty
      // this.form.setFieldsValue({
      //   state: "",
      //   city: ""
      // });
      this.location.selected_country = "";
      this.location.selected_country = this.$store.getters.countries.find(
        s => s.name === e
      ).name;
      // this.user.country = this.location.selected_country;
    },
    setState(e) {
      // this.form.setFieldsValue({
      //   city: ""
      // });
      this.location.selected_state = this.$store.getters.states.find(
        s => s.name === e
      ).name;
      // this.user.state = this.location.selected_state;
    },

    addUser(e) {
      // e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          const hide = this.$message.loading(
            "..Creating User - One Minute Please"
          );
          let data = {
            id: this.user && this.user.id ? this.user.id : "",
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            username: values.username,
            phone_number: values.home_telephone,
            password: values.password,
            password_confirmation: values.password,
            country_id: this.countries.find(s => {
              return s.name === this.location.selected_country;
            }).id,
            state_id: this.states.find(s => {
              return s.name === this.location.selected_state;
            }).id,
            city_id: this.cities.find(s => {
              return s.name === this.location.selected_city;
            }).id,
            street_address: values.address,
            zip_postal_code: values.zip_code,
            role_id: values.roles,
            mode: this.mode
          };
          this.$store
            .dispatch("addUser", data)
            .then(s => {
              setTimeout(hide, 20);
              this.$message.success("🤗 " + s.message);
            })
            .catch(err => {
              setTimeout(hide, 20);
              if (err.status === 422) {
                Object.values(err.data).forEach(s => {
                  this.$message.error("Sorry, " + s, 2.5);
                });
              }
            });
        }
      });
    }
  },
  mounted() {
    this.$store.dispatch("getCountries");
    this.$store.dispatch("getStates");
    this.$store.dispatch("getCities");
  },
};
</script>
